import type { City } from '../utils/activeCity'
import type { EmailIdentity } from '../types/emailIdentity'

/**
 * Default email identity per city, based on each city's public website
 * (brossard.ca, villedewindsor.qc.ca): contact details, hours and visual cues.
 */
export const DEFAULT_EMAIL_IDENTITY: Record<City, EmailIdentity> = {
  Brossard: {
    // Official Ville de Brossard signature (emblem, wordmark and "Vivre au présent. Bâtir le futur.").
    logoUrl: 'https://cdn.magicpatterns.com/uploads/7UUdBuvZHbm2usJ52eBTWe/image.png',
    primaryColor: '#0B4C9C',
    accentColor: '#FFC629',
    headerStyle: 'light',
    footerStyle: 'light',
    slogan: { fr: '', en: '' },
    headerTagline: { fr: 'Avis aux citoyens', en: 'Citizen notice' },
    footerText: ['Ville de Brossard', '2001, boulevard de Rome, Brossard (Québec) J4W 3K5', '450 923-6311'].join('\n'),
    email: 'services@brossard.ca',
    website: 'brossard.ca',
    socials: ['facebook', 'instagram', 'linkedin', 'youtube'],
    showSocial: true,
    showUnsubscribe: true,
  },
  Windsor: {
    logoUrl: 'https://cdn.magicpatterns.com/uploads/nedc6b9KaGTagFGJXbwvij/pasted-image.png',
    primaryColor: '#1F5F3F',
    accentColor: '#E0A526',
    headerStyle: 'light',
    footerStyle: 'light',
    slogan: { fr: '', en: '' },
    headerTagline: { fr: 'Avis aux citoyens', en: 'Citizen notice' },
    footerText: ['Ville de Windsor', '11, rue Saint-Georges, local 230, Windsor (Québec) J1S 2L7', '819 845-7888'].join('\n'),
    email: 'info@villedewindsor.qc.ca',
    website: 'villedewindsor.qc.ca',
    socials: ['facebook'],
    showSocial: true,
    showUnsubscribe: true,
  },
}
